angular.module('zc.projects')

.directive 'zcPageTypeEditor', (PageType, PageTypeSampleUrl) ->
    restrict: 'E'
    scope:
      projectId: '='
    templateUrl: '/templates/projects.settings/initialization/page_type_editor.html'
    link: (scope, element, attrs) ->
      # only this specific functionality
      scope.pageTypes = []
      scope.pageTypeSampleUrls = []

      PageTypeSampleUrl.all(scope.projectId)
      .then (pageTypeSampleUrls) ->
        scope.pageTypeSampleUrls = pageTypeSampleUrls
        PageType.all(scope.projectId)
        .then (pageTypes) ->
          scope.pageTypes = _.reject pageTypes,
            page_type: 'no_publish'
          scope.checkAllSampleMatchesPattern()

      scope.addPageType = () ->
        scope.pageTypes.push(PageType.new({ project_id: scope.projectId}))

      scope.addPageTypeSampleUrl = () ->
        scope.pageTypeSampleUrls.push(PageTypeSampleUrl.new({ project_id: scope.projectId}))

      scope.onDestroy = (pageType) ->
        return unless pageType
        scope.pageTypes.splice(scope.pageTypes.indexOf(pageType), 1)

      scope.onDestroySampleUrl = (pageTypeSampleUrl) ->
        return unless pageTypeSampleUrl
        scope.pageTypeSampleUrls.splice(scope.pageTypeSampleUrls.indexOf(pageTypeSampleUrl), 1)

      getSampleUrlAfterPathname = (url) ->
        parser = document.createElement('a')
        parser.href = url
        sampleUrlAfterPathname = parser.pathname + parser.search + parser.hash

      # NOTE: this is exactly same code as publish.js! (shared code)
      checkMatch = (val, match_type, match_pattern) ->
        return false unless val and match_type and match_pattern
        switch match_type
          when 'prefix'
            if val.indexOf(match_pattern) is 0
              return true
          when 'regexp'
            if val.match(match_pattern)
              return true
          when 'full'
            if val is match_pattern
              return true
          when 'partial'
            if val.indexOf(match_pattern) >= 0
              return true
        false

      checkSampleMatchesPatternByPageType = (pageType, pageTypeSampleUrl) ->

        unless pageType.required_device == pageTypeSampleUrl.required_device or pageType.required_device == 'both' or pageTypeSampleUrl.required_device == 'both'
          return false

        sampleUrl = pageTypeSampleUrl.url
        sampleUrlAfterPathname = getSampleUrlAfterPathname sampleUrl

        isMatch = false
        for url in [sampleUrl, sampleUrlAfterPathname]
          try isMatch = true if checkMatch(url, pageType.match_type, pageType.match_pattern)
        isMatch

      scope.checkSampleMatchesPattern = (pageTypeSampleUrl) ->
        pageTypeSampleUrl.page_types = []
        pageTypeSampleUrl.isOk = false
        for pageType in scope.pageTypes
          if checkSampleMatchesPatternByPageType(pageType, pageTypeSampleUrl)
            if pageType.page_type is '_custom_'
              pageTypeSampleUrl.page_types.push pageType.custom_name
            else
              pageTypeSampleUrl.page_types.push pageType.page_type
        if pageTypeSampleUrl.page_types.length > 0
          pageTypeSampleUrl.isOk = pageTypeSampleUrl.page_types[0] == pageTypeSampleUrl.page_type # Should be judged by in

      scope.checkAllSampleMatchesPattern = ()->
        for pageTypeSampleUrl in scope.pageTypeSampleUrls
          scope.checkSampleMatchesPattern(pageTypeSampleUrl)



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/initialization/page_type_editor.directive.coffee